import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "257.516 158.797 327.636 277.964",
  "content": "<symbol viewBox=\"257.516 158.797 327.636 277.964\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow\">\n    <rect x=\"547.746\" y=\"158.797\" width=\"37.406\" height=\"277.964\" />\n    <polygon points=\"257.516,297.778 369.017,409.279 395.466,382.83 329.119,316.481 515.429,316.481 515.429,279.075 329.119,279.075\n\t395.466,212.729 369.017,186.278 283.966,271.328 283.966,271.328 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol